export type SubNavItem = {
  label: string;
  path: string;
  description: string;
};

export type NavItem = {
  label: string;
  path: string;
  submenu?: SubNavItem[];
};

export const NAV: NavItem[] = [
  {
    label: "About",
    path: "/about",
    submenu: [
      { label: "Who We Are", path: "/about", description: "Our origin, values and approach." },
      { label: "Leadership Team", path: "/about/leadership", description: "The people who lead MCC." },
      { label: "Our Campus", path: "/about/campus", description: "Step inside Maple in Lekki." },
      { label: "Success Stories", path: "/success-stories", description: "Students and parents, in their own words." },
    ],
  },
  {
    label: "Academics",
    path: "/academics",
    submenu: [
      { label: "Academic Overview", path: "/academics", description: "How the OSSD pathway works at MCC." },
      { label: "Curriculum & Courses", path: "/academics/curriculum", description: "The University Pathway Program." },
      { label: "University Pathways", path: "/academics/pathways", description: "Where the OSSD can lead." },
      { label: "Scholarships & Results", path: "/academics/scholarships", description: "Awards our graduates have earned." },
      { label: "Honour Row", path: "/academics/honour-row", description: "Students who finished at 90% and above." },
      { label: "Summer School", path: "/academics/summer-school", description: "A head start over the holidays." },
    ],
  },
  {
    label: "Admissions",
    path: "/admissions",
    submenu: [
      { label: "Admissions & Intakes", path: "/admissions", description: "September and January intakes." },
      { label: "Fast Track Programme", path: "/admissions/fast-track", description: "The five-month route to the OSSD." },
      { label: "Entry Requirements", path: "/admissions/requirements", description: "Criteria for a place at MCC." },
      { label: "Apply", path: "/admissions/apply", description: "Start an application." },
    ],
  },
  {
    label: "Student Life",
    path: "/student-life",
    submenu: [
      { label: "Extra-Curricular Activities", path: "/student-life", description: "Clubs, sport, arts and leadership." },
      { label: "Sports Fiesta", path: "/student-life/sports-fiesta", description: "MCC’s big day on the field." },
      { label: "Boarding", path: "/boarding", description: "Girls’ and boys’ residences." },
    ],
  },
  { label: "Fees & Payments", path: "/admissions/fees" },
  {
    label: "News & Events",
    path: "/news",
    submenu: [
      { label: "News & Events", path: "/news", description: "Announcements and school life." },
      { label: "Graduations", path: "/news/graduations", description: "Every graduating class, in photos and film." },
      { label: "Gallery", path: "/gallery", description: "Life at MCC, in pictures." },
      { label: "Blog", path: "/news/blog", description: "Guides and insight for families." },
      { label: "Careers", path: "/news/careers", description: "Teach and work at MCC." },
      { label: "Alumni Portal", path: "/alumni", description: "For MCC graduates." },
    ],
  },
  { label: "Contact", path: "/contact" },
];
